import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { QUERY_PARAMS, useAuth, useOnboardingStore } from '#layers/access/public';
import { firstString, useSystemInfo } from '#layers/base/public';
import { isUnderTest } from '~/utils/env/is-under-test';

/**
 * Pages only accessible if not logged in. Redirect to home if user is logged in.
 *
 * When the system still needs its first user, force login → create-user and
 * the inverse when not.
 */
export default defineNuxtRouteMiddleware(async (to) => {
	if (isUnderTest()) {
		return;
	}

	const onboarding = useOnboardingStore();
	const systemInfo = useSystemInfo();
	const auth = useAuth();
	await Promise.all([auth.ensureInitialized(), systemInfo.ensureLoaded()]);

	// The probe above races the auth token refresh, so it can miss the authenticated section.
	if (auth.loggedIn) await systemInfo.ensureAuthenticatedLoaded();

	if (auth.loggedIn) {
		return '/';
	}

	if (onboarding.requireCreateUser && to.name !== 'onboarding.create-user') {
		const redirect = firstString(to.query[QUERY_PARAMS.redirect]);

		if (redirect) {
			return {
				name: 'onboarding.create-user',
				query: { [QUERY_PARAMS.redirect]: redirect },
			};
		}

		return { name: 'onboarding.create-user' };
	}

	if (!onboarding.requireCreateUser && to.name === 'onboarding.create-user') {
		return { name: 'auth.login' };
	}
});
